import { render } from "./CookiesPolicy.vue?vue&type=template&id=3494bbf7&scoped=true"
const script = {}

import "./CookiesPolicy.vue?vue&type=style&index=0&id=3494bbf7&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3494bbf7"]])

export default __exports__